(() => {
  if (window.__acsProductSpinViewerBootstrapped) {
    if (typeof window.__acsInitializeProductSpinViewers === 'function') {
      window.__acsInitializeProductSpinViewers(document);
    }
    return;
  }
  window.__acsProductSpinViewerBootstrapped = true;

  const CORE_SPIN_ATLAS_CATALOG = {
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic00-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472819380596",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core00-7g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic00-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472819413364",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core00-15g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic00-core30g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472819446132",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core00-30g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic01-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53628650520948",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-no1-7g-v4.webp?v=1793689682"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic01-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53628650553716",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core01-15g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic01-core30g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53628650586484",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core01-30g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic02-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472065290612",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core02-7g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic02-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472065388916",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core02-15g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic02-core30g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472065487220",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core02-30g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic03-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472793231732",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core03-7g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic03-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472793461108",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core03-15g-v001-a20261103-v5.webp?v=1793692907"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic03-core30g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472793690484",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core03-30g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic04-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472796508532",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core04-7g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic04-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472796737908",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core04-15g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic04-core30g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472796967284",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core04-30g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic05-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472797393268",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core05-7g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic05-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472797622644",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core05-15g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic05-core30g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472797852020",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core05-30g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic06-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472798769524",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core06-7g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic06-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472798998900",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core06-15g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic06-core30g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472799228276",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core06-30g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic07-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472818659700",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core07-7g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic07-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472818889076",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core07-15g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic07-core30g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472819118452",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core07-30g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic08-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472817971572",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core08-7g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic08-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472818200948",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core08-15g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic08-core30g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472818430324",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core08-30g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic09-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472817283444",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core09-7g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic09-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472817512820",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core09-15g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic09-core30g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472817742196",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core09-30g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic10-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472816529780",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core10-7g-v001-a20261103-v5.webp?v=1793692906"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic10-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472816759156",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core10-15g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic10-core30g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472816988532",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core10-30g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic11-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472815841652",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core11-7g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic11-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472816071028",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core11-15g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic11-core30g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472816300404",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core11-30g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic12-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472815120756",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core12-7g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic12-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472815350132",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core12-15g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic12-core30g-v002-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v002",
    "variant": "53472815579508",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core12-30g-v002-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic13-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472814432628",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core13-7g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic13-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472814662004",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core13-15g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic13-core30g-v002-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v002",
    "variant": "53472814891380",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core13-30g-v002-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic14-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472813252980",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core14-7g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic14-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472813482356",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core14-15g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic14-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472813711732",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core14-30g-v003-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic15-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472812433780",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core15-7g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic15-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472812663156",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core15-15g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic15-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472812892532",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core15-30g-v003-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic16-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472811745652",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core16-7g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic16-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472811975028",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core16-15g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic16-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472812204404",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core16-30g-v003-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic17-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472811057524",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core17-7g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic17-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472811286900",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core17-15g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic17-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472811516276",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core17-30g-v003-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic18-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472810369396",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core18-7g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic18-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472810598772",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core18-15g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic18-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472810828148",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core18-30g-v003-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic19-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472809582964",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core19-7g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic19-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472809812340",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core19-15g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic19-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472810041716",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core19-30g-v003-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic20-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472808894836",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core20-7g-v001-a20261103-v5.webp?v=1793694672"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic20-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472809124212",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core20-15g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic20-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472809353588",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core20-30g-v003-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic21-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472808141172",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core21-7g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic21-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472808370548",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core21-15g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic21-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472808599924",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core21-30g-v003-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic22-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472807158132",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core22-7g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic22-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472807387508",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core22-15g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic22-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472807616884",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core22-30g-v003-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic23-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472806470004",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core23-7g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic23-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472806699380",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core23-15g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic23-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472806928756",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core23-30g-v003-a20261103-v5.webp?v=1793694710"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic24-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472805618036",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core24-7g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic24-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472805847412",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core24-15g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic24-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472806076788",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core24-30g-v003-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic25-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472804864372",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core25-7g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic25-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472805093748",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core25-15g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic25-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472805323124",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core25-30g-v003-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic26-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472803750260",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core26-7g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic26-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472803979636",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core26-15g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic26-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472804209012",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core26-30g-v003-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic27-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472803029364",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core27-7g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic27-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472803258740",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core27-15g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic27-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472803488116",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core27-30g-v003-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic28-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472800342388",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core28-7g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic28-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472800571764",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core28-15g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic28-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472800801140",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core28-30g-v003-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic29-core7g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472798081396",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core29-7g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic29-core15g-v001-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v001",
    "variant": "53472798310772",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core29-15g-v001-a20261103-v5.webp?v=1793694709"
  },
  "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-frame-intrinsic29-core30g-v003-": {
    "count": 169,
    "pad": 3,
    "ext": "webp",
    "version": "v003",
    "variant": "53472798540148",
    "url": "https://cdn.shopify.com/s/files/1/0944/0398/5780/files/spin-atlas-core29-30g-v003-a20261103-v5.webp?v=1793694709"
  }
};

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mobileSpinMediaQuery = window.matchMedia('(max-width: 767px)');
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  const slowConnection = Boolean(navigator.connection && /(^|-)2g$/.test(navigator.connection.effectiveType || ''));

  const normalizeConfig = (input = {}) => {
    const base = input.base || '';
    const count = Number(input.count || 0);
    const pad = Number(input.pad || 3);
    const ext = input.ext || 'webp';
    const version = input.version || '';
    const poster = input.poster || '';
    const title = input.title || '';
    const options = Array.isArray(input.options) ? input.options : [];
    const values = Array.isArray(input.values) ? input.values : [];
    if (!base || !Number.isFinite(count) || count <= 0) return null;
    return { base, count, pad, ext, version, poster, title, options, values };
  };

  const configFromDataset = (viewer) => normalizeConfig({
    base: viewer.dataset.frameBase || '',
    count: viewer.dataset.frameCount || 0,
    pad: viewer.dataset.framePad || 3,
    ext: viewer.dataset.frameExt || 'webp',
    version: viewer.dataset.frameVersion || '',
    poster: viewer.dataset.posterUrl || '',
  });

  const productFallbackConfig = (viewer) => normalizeConfig({
    base: viewer.dataset.productFrameBase || viewer.dataset.frameBase || '',
    count: viewer.dataset.productFrameCount || viewer.dataset.frameCount || 0,
    pad: viewer.dataset.framePad || 3,
    ext: viewer.dataset.frameExt || 'webp',
    version: viewer.dataset.productFrameVersion || viewer.dataset.frameVersion || '',
    poster: viewer.dataset.posterUrl || '',
  });

  const buildFrames = (config) => {
    if (!config) return [];
    return Array.from({ length: config.count }, (_, index) => {
      const frame = String(index + 1).padStart(config.pad, '0');
      const url = new URL(`${config.base}${frame}.${config.ext}`, window.location.href);
      // Lightweight derivatives are limited to the known Shopify intrinsic spin-frame assets on mobile.
      if (mobileSpinMediaQuery.matches && /^https:\/\/cdn\.shopify\.com$/.test(url.origin) && /(?:^|\/)files\/spin-frame-intrinsic[^/]+\.webp$/i.test(url.pathname)) {
        url.searchParams.set('width', '1024');
      }
      return url.href;
    });
  };

  const parseVariantConfigs = (viewer) => {
    const node = viewer.querySelector('[data-product-spin-variant-frames]');
    if (!node || !node.textContent.trim()) return new Map();

    try {
      const raw = JSON.parse(node.textContent);
      return new Map(Object.entries(raw).map(([variantId, config]) => [
        String(variantId),
        normalizeConfig({
          base: config.base,
          count: config.count,
          version: config.version,
          poster: config.poster,
          title: config.title,
          options: config.options,
          values: config.values,
          pad: viewer.dataset.framePad || 3,
          ext: viewer.dataset.frameExt || 'webp',
        }),
      ]));
    } catch (_error) {
      return new Map();
    }
  };

  const selectedVariantIdFromField = (field) => {
    if (!field) return '';
    if (field.matches('select')) return field.value;
    if ((field.matches('[type="radio"]') || field.matches('[type="checkbox"]')) && !field.checked) return '';
    return field.value || '';
  };

  const normalizeOptionValue = (value) => String(value || '').trim().toLowerCase();

  const optionNameFromControl = (field, productId) => {
    const rawName = field.getAttribute('name') || '';
    const optionsMatch = rawName.match(/^options\[(.+)\]$/);
    if (optionsMatch) return optionsMatch[1].trim();
    if (productId && rawName.startsWith(`${productId}-`)) return rawName.slice(String(productId).length + 1).trim();

    const fieldset = field.closest('fieldset');
    const legend = fieldset && fieldset.querySelector('legend');
    return legend ? legend.textContent.trim() : '';
  };

  const selectedOptionsFromControls = (viewer) => {
    const productId = viewer.dataset.productId || '';
    const controls = document.querySelectorAll('.js-variants input[type="radio"]:checked, .js-variants select');
    const byName = new Map();
    const values = [];

    controls.forEach((field) => {
      if (!(field instanceof HTMLInputElement) && !(field instanceof HTMLSelectElement)) return;
      if (field.disabled) return;

      const rawName = field.getAttribute('name') || '';
      if (productId && rawName && !rawName.startsWith(`${productId}-`) && !rawName.startsWith('options[')) return;

      const value = field.value || '';
      if (!value) return;

      const optionName = optionNameFromControl(field, productId);
      if (optionName) byName.set(optionName, value);
      values.push(value);
    });

    return { byName, values };
  };

  const initializeProductSpinViewers = (root = document) => {
    const viewers = [];
    if (root instanceof Element && root.matches('[data-product-spin-viewer]')) viewers.push(root);
    if (root && typeof root.querySelectorAll === 'function') {
      viewers.push(...root.querySelectorAll('[data-product-spin-viewer]'));
    }

    viewers.forEach((viewer) => {
    if (viewer.dataset.productSpinReady === 'true') return;
    viewer.dataset.productSpinReady = 'true';
    viewer.dataset.productSpinDragEngine = 'buffered-20261103';
    viewer.dataset.productSpinPointerControl = 'adaptive-20261103-v2';
    viewer.dataset.productSpinSliderControl = 'continuous-mobile-20261103-v3';

    const stage = viewer.querySelector('[data-product-spin-stage]');
    const image = viewer.querySelector('[data-product-spin-image]');
    const range = viewer.querySelector('[data-product-spin-range]');
    const statusNode = viewer.querySelector('[data-product-spin-status]');
    const hintNode = viewer.querySelector('[data-product-spin-hint]');
    const activateNode = viewer.querySelector('[data-product-spin-activate]');
    const variantConfigs = parseVariantConfigs(viewer);
    const fallbackConfig = productFallbackConfig(viewer);
    const frameStatusTemplate = viewer.dataset.frameStatusTemplate || 'Frame __current__ of __total__';
    let activeConfig = configFromDataset(viewer) || fallbackConfig;
    let frames = buildFrames(activeConfig);
    const posterMode = viewer.dataset.posterMode === 'true';

    if (!stage || !image || !range || !frames.length) return;

    const imageAlt = image.getAttribute('alt') || '';
    const bufferImage = image.cloneNode(false);
    bufferImage.classList.remove('is-active');
    bufferImage.removeAttribute('data-product-spin-image');
    bufferImage.setAttribute('aria-hidden', 'true');
    bufferImage.setAttribute('alt', '');
    stage.appendChild(bufferImage);

    const clamp = (index) => Math.min(Math.max(index, 0), frames.length - 1);

    const initialFrameIndex = () => {
      const initial = Number(viewer.dataset.initialFrame || 1);
      const normalized = Number.isFinite(initial) && initial > 0 ? initial : 1;
      return clamp(normalized - 1);
    };

    let frame = initialFrameIndex();
    let decodedFrames = new Map();
    let pendingFrames = new Map();
    let activeImage = image;
    let standbyImage = bufferImage;
    let spinRequested = false;
    let frameGeneration = 0;
    let activeFrameLoads = 0;
    let frameQueue = [];
    let statusTimer = 0;
    let wheelDelta = 0;
    let renderToken = 0;
    let lastVariantId = viewer.dataset.currentVariantId || '';
    let posterActive = Boolean(posterMode && activeConfig && activeConfig.poster);
    let controlsReady = !posterActive;
    // Approved mobile Core renderer: exactly catalogued variants, all 169 existing views.
    let spinAtlasImage = null;
    let spinAtlasCanvas = null;
    let spinAtlasContext = null;
    let spinAtlasReady = false;
    let spinAtlasLoading = false;
    let spinAtlasVisible = false;
    let spinAtlasGeneration = 0;
    let spinAtlasTimeout = 0;
    let spinAtlasRaf = 0;
    let spinAtlasNotice = null;
    let spinAtlasGeometry = null;
    const spinPhotoVisibility = new WeakMap();
    // The cache retains decoded nodes, not just URLs. The two stage nodes plus
    // in-flight loads stay bounded independently of the total frame count.
    const constrainedSpin = saveData || slowConnection;
    const mobileSpin = mobileSpinMediaQuery.matches;
    const frameQueueLimit = constrainedSpin ? 6 : 12;
    const frameLoadLimit = constrainedSpin ? 1 : (mobileSpin ? 2 : 4);
    const decodedByteBudget = (constrainedSpin ? 48 : (mobileSpin ? 64 : 128)) * 1024 * 1024;
    const maximumCachedFrames = constrainedSpin ? 2 : (mobileSpin ? 8 : 12);
    const initialFrameWidth = frames[0] && new URL(frames[0]).searchParams.get('width');
    let estimatedFrameBytes = Math.pow(Number(initialFrameWidth) || 1600, 2) * 4;
    const frameCacheLimit = () => Math.max(1, Math.min((spinAtlasReady || spinAtlasLoading) ? 2 : maximumCachedFrames,
      Math.floor(decodedByteBudget / estimatedFrameBytes) - frameLoadLimit - 2));
    let displayedFrame = frame;
    let dragRaf = 0;
    let dragRendering = false;
    let dragDirection = 0;
    let dragVelocity = 0;
    let dragSampleTime = 0;
    let dragSampleFrame = frame;
    let dragPointerId = null;
    let dragStartX = 0;
    let dragStartY = 0;
    let dragLastX = 0;
    let dragDistance = 0;
    let draggingSpin = false;
    let dragPointerType = 'mouse';
    let dragPixelsPerFrame = 12;
    let sliderGestureActive = false;
    let sliderTouchId = null;
    let sliderPointerId = null;
    let sliderSettleTimer = 0;
    let sliderLastSettledValue = '';

    const sliderTarget = () => Number(range.value) - 1;
    const renderSliderTarget = () => {
      const next = clamp(sliderTarget());
      if (!sliderGestureActive) { showFrame(next); return; }
      if (next === frame) return;
      // A range is an absolute view selector. If its thumb reverses while the
      // image is still behind, keep progressing toward the newest selected view.
      dragDirection = Math.sign(next - displayedFrame) || Math.sign(next - frame);
      frame = next;
      renderToken += 1;
      if (spinAtlasReady && spinAtlasEligible()) {
        cancelDragRender();
        scheduleSpinAtlasRender();
        return;
      }
      dragRendering = true;
      scheduleDragRender();
    };
    const settleSlider = () => {
      if (!sliderGestureActive) return;
      sliderGestureActive = false;
      sliderTouchId = null;
      sliderPointerId = null;
      window.clearTimeout(sliderSettleTimer);
      sliderSettleTimer = 0;
      const target = sliderTarget();
      sliderLastSettledValue = String(target);
      showFrame(target);
      beginIdlePreload();
    };
    const startSliderGesture = (event) => {
      if (event && event.pointerType === 'mouse' && event.button !== 0) return;
      prepareSpinAtlas();
      if (event && event.isPrimary === false) return;
      if (sliderGestureActive && sliderTouchId !== null && event && event.pointerType === 'touch') {
        sliderPointerId = event.pointerId;
        return;
      }
      sliderGestureActive = true;
      sliderPointerId = event && event.pointerId !== undefined ? event.pointerId : null;
      sliderTouchId = null;
      sliderLastSettledValue = '';
      window.clearTimeout(sliderSettleTimer);
      if (spinAtlasReady && spinAtlasEligible()) {
        renderToken += 1;
        cancelDragRender();
        refreshSpinAtlasGeometry();
        drawSpinAtlas(frame, true);
      }
    };
    const scheduleSliderFallback = () => {
      window.clearTimeout(sliderSettleTimer);
      sliderSettleTimer = window.setTimeout(() => {
        sliderSettleTimer = 0;
        if (sliderGestureActive && !(spinAtlasReady && spinAtlasEligible())) showFrame(sliderTarget());
      }, 450);
    };

    const cancelDragRender = () => {
      if (dragRaf) window.cancelAnimationFrame(dragRaf);
      dragRaf = 0;
      dragRendering = false;
    };

    const waitForImage = (targetImage) => {
      if (targetImage.complete && targetImage.naturalWidth > 0) return Promise.resolve(true);

      const loadPromise = new Promise((resolve) => {
        targetImage.onload = () => resolve(targetImage.naturalWidth > 0);
        targetImage.onerror = () => resolve(false);
      });

      if (!targetImage.decode) return loadPromise;
      return targetImage.decode()
        .then(() => targetImage.naturalWidth > 0)
        .catch(() => loadPromise);
    };

    const updateRangeProgress = () => {
      const max = Math.max(frames.length - 1, 1);
      range.style.setProperty('--product-spin-progress', `${(frame / max) * 100}%`);
    };

    const updateStatus = () => {
      const visibleFrame = frame + 1;
      const frameStatus = frameStatusTemplate
        .replace(/__current__/g, String(visibleFrame))
        .replace(/__total__/g, String(frames.length));
      range.min = '1';
      range.max = String(frames.length);
      range.step = '1';
      range.value = String(visibleFrame);
      range.setAttribute('aria-valuetext', frameStatus);
      updateRangeProgress();

      if (!statusNode) return;
      window.clearTimeout(statusTimer);
      statusTimer = window.setTimeout(() => {
        statusNode.textContent = frameStatus;
      }, 120);
    };

    const stopSpinTouchLeak = (node, options = {}) => {
      if (!node) return;
      const preventMove = Boolean(options.preventMove);
      const events = ['pointerdown', 'pointermove', 'pointerup', 'mousedown', 'mousemove', 'mouseup', 'touchstart', 'touchmove', 'touchend'];

      events.forEach((eventName) => {
        node.addEventListener(eventName, (event) => {
          event.stopPropagation();
          if (preventMove && event.cancelable && (eventName === 'touchmove' || eventName === 'pointermove')) {
            event.preventDefault();
          }
        }, { capture: true, passive: false });
      });
    };

    const setControlsReady = (ready) => {
      controlsReady = Boolean(ready);
      viewer.classList.toggle('is-spin-ready', controlsReady);

      if (activateNode) {
        activateNode.setAttribute('aria-hidden', controlsReady ? 'true' : 'false');
        activateNode.tabIndex = controlsReady ? -1 : 0;
      }

      range.disabled = !controlsReady;
      range.tabIndex = controlsReady ? 0 : -1;

      if (!hintNode) return;
      if (controlsReady && !viewer.classList.contains('is-spin-active')) {
        hintNode.removeAttribute('aria-hidden');
      } else {
        hintNode.setAttribute('aria-hidden', 'true');
      }
    };

    const syncPosterClass = () => {
      viewer.classList.toggle('is-poster-active', posterActive);
    };

    const focusSpinSlide = (speed = 0) => {
      const slider = viewer.closest('.js-product-media-items');
      if (!slider || !slider.swiper) return;
      if (typeof slider.swiper.slideToLoop === 'function') {
        slider.swiper.slideToLoop(0, speed);
        return;
      }
      slider.swiper.slideTo(0, speed);
    };

    const scheduleSpinSlideFocus = () => {
      if (!posterMode) return;
      [0, 80, 240, 500].forEach((delay) => {
        window.setTimeout(() => focusSpinSlide(0), delay);
      });
    };

    const showCurrentFramePreview = () => {
      if (!posterActive || !frames[frame]) return;
      posterActive = false;
      syncPosterClass();
      const next = frame;
      const generation = frameGeneration;
      const token = ++renderToken;
      loadFrame(next, true).then((loadedImage) => {
        if (generation !== frameGeneration || token !== renderToken || posterActive || frame !== next) return;
        if (loadedImage) renderReadyFrame(next, loadedImage);
      });
      preloadAround(frame, saveData || slowConnection ? 1 : 4);
    };

    const activateControls = (event) => {
      spinRequested = true;
      if (!posterMode || controlsReady) return;
      if (event) event.preventDefault();
      showCurrentFramePreview();
      setControlsReady(true);
      focusSpinSlide(0);
      prepareSpinAtlas();
    };

    const markSpinActive = () => {
      if (!controlsReady) setControlsReady(true);
      if (!posterActive) return;
      posterActive = false;
      syncPosterClass();
      viewer.classList.add('is-spin-active');
      if (hintNode) hintNode.setAttribute('aria-hidden', 'true');
    };

    const updateLinkedThumb = (poster) => {
      if (!poster) return;
      const mediaSlider = viewer.closest('.m-product-media');
      const optionThumbs = mediaSlider && mediaSlider.querySelectorAll('[data-product-spin-option-thumb]');
      if (optionThumbs && optionThumbs.length) {
        syncOptionThumbs(activeConfig);
        return;
      }

      const thumbImage = mediaSlider && mediaSlider.querySelector('[data-product-spin-thumb]');
      if (!thumbImage) return;
      thumbImage.setAttribute('src', poster);
      thumbImage.removeAttribute('srcset');
    };

    const syncOptionThumbs = (config = activeConfig) => {
      const mediaSlider = viewer.closest('.m-product-media');
      if (!mediaSlider) return;

      const optionThumbs = mediaSlider.querySelectorAll('[data-product-spin-option-thumb]');
      if (!optionThumbs.length) return;

      const values = config && Array.isArray(config.values) ? config.values.map(normalizeOptionValue) : [];
      const title = normalizeOptionValue(config && config.title);

      optionThumbs.forEach((thumb) => {
        const value = normalizeOptionValue(thumb.dataset.productSpinOptionValue);
        const active = values.includes(value) || title === value;
        thumb.classList.toggle('is-spin-option-active', active);
        if (active) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    };

    const resetPosterState = () => {
      if (!posterMode || !activeConfig || !activeConfig.poster) return;

      releaseSpinAtlas();
      cancelDragRender();
      renderToken += 1;
      draggingSpin = false;
      dragPointerId = null;
      dragDistance = 0;
      sliderGestureActive = false; sliderTouchId = null; sliderPointerId = null; window.clearTimeout(sliderSettleTimer); sliderSettleTimer = 0;
      stage.classList.remove('is-spin-dragging');
      // These stage nodes are about to change source. Do not retain a cache
      // entry that would now masquerade as a decoded frame but contain a poster.
      for (const [index, cachedImage] of decodedFrames) {
        if (cachedImage === activeImage || cachedImage === standbyImage) decodedFrames.delete(index);
      }
      posterActive = true;
      controlsReady = false;
      viewer.classList.remove('is-spin-active');
      activeImage.src = activeConfig.poster;
      activeImage.classList.add('is-active');
      activeImage.setAttribute('data-product-spin-image', '');
      activeImage.removeAttribute('aria-hidden');
      activeImage.setAttribute('alt', imageAlt);
      standbyImage.removeAttribute('src');
      standbyImage.classList.remove('is-active');
      standbyImage.removeAttribute('data-product-spin-image');
      standbyImage.setAttribute('aria-hidden', 'true');
      standbyImage.setAttribute('alt', '');
      syncPosterClass();
      setControlsReady(false);
      updateStatus();
      preloadAround(frame, saveData || slowConnection ? 1 : 4);
    };

    const selectVariantControl = (value) => {
      const selectedValue = normalizeOptionValue(value);
      if (!selectedValue) return false;

      const productId = viewer.dataset.productId || '';
      let selected = false;

      document.querySelectorAll('.js-variants input[type="radio"]').forEach((input) => {
        if (!(input instanceof HTMLInputElement) || input.disabled) return;

        const rawName = input.getAttribute('name') || '';
        if (productId && rawName && !rawName.startsWith(`${productId}-`) && !rawName.startsWith('options[')) return;
        if (normalizeOptionValue(input.value) !== selectedValue) return;

        if (!input.checked) {
          input.checked = true;
          input.dispatchEvent(new Event('input', { bubbles: true }));
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        selected = true;
      });

      if (selected) return true;

      document.querySelectorAll('.js-variants select').forEach((select) => {
        if (!(select instanceof HTMLSelectElement) || select.disabled) return;

        const rawName = select.getAttribute('name') || '';
        if (productId && rawName && !rawName.startsWith(`${productId}-`) && !rawName.startsWith('options[')) return;

        const option = Array.from(select.options).find((item) => normalizeOptionValue(item.value) === selectedValue);
        if (!option) return;

        select.value = option.value;
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
        selected = true;
      });

      return selected;
    };

    const slideMainToMediaId = (mediaId, speed = 0) => {
      const mediaSlider = viewer.closest('.m-product-media');
      const slider = mediaSlider && mediaSlider.querySelector('.js-product-media-items');
      if (!slider || !mediaId) return;

      const slideToMedia = () => {
        const slide = Array.from(slider.querySelectorAll('.swiper-slide[data-media-id]')).find(
          (item) => item.dataset.mediaId === String(mediaId),
        );
        if (!slide) return;

        if (slider.swiper) {
          slider.swiper.updateSize();
          slider.swiper.updateSlides();
          const index = Array.from(slider.swiper.slides).indexOf(slide);
          if (index >= 0) {
            slider.swiper.slideTo(index, speed);

            // Responsive preview/device rotation can leave Swiper's cached
            // translate one slide behind even though the active class changes.
            // On the mobile static-mode tabs, pin the requested media to the
            // viewport using the freshly measured slide offset.
            if (mobileSpinMediaQuery.matches) {
              window.requestAnimationFrame(() => {
                slider.swiper.updateSize();
                slider.swiper.updateSlides();
                const offset = Number(slide.swiperSlideOffset ?? slide.offsetLeft ?? 0);
                const translate = slider.swiper.rtlTranslate ? offset : -offset;
                slider.swiper.setTranslate(translate);
                slider.swiper.updateProgress(translate);
                slider.swiper.updateActiveIndex(index);
                slider.swiper.updateSlidesClasses();
              });
            }
          }
          return;
        }

        slide.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };

      slideToMedia();
      [80, 240, 500].forEach((delay) => {
        window.setTimeout(slideToMedia, delay);
      });
    };

    const mediaSlideForId = (mediaId) => {
      const mediaSlider = viewer.closest('.m-product-media');
      const slider = mediaSlider && mediaSlider.querySelector('.js-product-media-items');
      if (!slider || !mediaId) return null;

      return Array.from(slider.querySelectorAll('.swiper-slide[data-media-id]')).find(
        (item) => item.dataset.mediaId === String(mediaId),
      ) || null;
    };

    const setVideoPreviewVisible = (video, visible) => {
      const slide = video && video.closest('.m-product-media__item');
      const overlay = slide && slide.querySelector('.a-video__overlay');
      if (!overlay) return;
      overlay.classList.toggle('hide', !visible);
    };

    const prepareMediaSlide = (slide) => {
      if (!slide) return null;

      const mediaImage = slide.querySelector('img');
      if (mediaImage) {
        mediaImage.loading = 'eager';
        mediaImage.fetchPriority = 'high';
        if (typeof mediaImage.decode === 'function') mediaImage.decode().catch(() => {});
      }

      const video = slide.querySelector('video');
      if (!video) return null;

      video.preload = 'auto';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');

      if (video.dataset.productMediaModeBound !== 'true') {
        video.dataset.productMediaModeBound = 'true';
        video.addEventListener('playing', () => setVideoPreviewVisible(video, false));
        video.addEventListener('loadeddata', () => {
          if (!video.paused) setVideoPreviewVisible(video, false);
        });
        video.addEventListener('error', () => setVideoPreviewVisible(video, true));
      }

      if (video.readyState === HTMLMediaElement.HAVE_NOTHING) video.load();
      return video;
    };

    const setActiveMediaThumb = (thumb) => {
      const thumbs = thumb && thumb.closest('.js-product-media-thumbs');
      if (!thumbs) return;

      thumbs.querySelectorAll('.m-product-media__thumb').forEach((item) => {
        item.classList.remove('swiper-slide-thumb-active');
      });
      thumb.classList.add('swiper-slide-thumb-active');

      if (thumbs.swiper) {
        const index = Array.from(thumbs.swiper.slides).indexOf(thumb);
        if (index >= 0) thumbs.swiper.slideTo(index, 0);
      }
    };

    const setActiveMediaMode = (button) => {
      const mediaSlider = viewer.closest('.m-product-media');
      if (!mediaSlider) return;

      const targetMediaId = button && button.dataset.mediaId;
      mediaSlider.querySelectorAll('.m-product-media__main-slider .swiper-slide[data-media-id]').forEach((slide) => {
        slide.classList.toggle(
          'is-product-media-mode-active',
          Boolean(targetMediaId) && slide.dataset.mediaId === String(targetMediaId),
        );
      });

      mediaSlider.querySelectorAll('[data-product-media-mode-button]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    const mediaModeButtonForId = (mediaId) => {
      const mediaSlider = viewer.closest('.m-product-media');
      if (!mediaSlider || !mediaId) return null;

      return Array.from(mediaSlider.querySelectorAll('[data-product-media-mode-button]')).find(
        (button) => button.dataset.mediaId === String(mediaId),
      ) || null;
    };

    const mediaThumbForId = (mediaId) => {
      const mediaSlider = viewer.closest('.m-product-media');
      if (!mediaSlider || !mediaId) return null;

      return Array.from(mediaSlider.querySelectorAll('.m-product-media__thumb[data-media-id]')).find(
        (thumb) => thumb.dataset.mediaId === String(mediaId),
      ) || null;
    };

    const pauseProductMediaVideos = (activeVideo = null) => {
      const mediaSlider = viewer.closest('.m-product-media');
      if (!mediaSlider) return;
      mediaSlider.querySelectorAll('video').forEach((video) => {
        if (video === activeVideo) return;
        video.pause();
        setVideoPreviewVisible(video, true);
      });
    };

    const activateSpinMediaMode = (resetPoster = true) => {
      const mediaSlider = viewer.closest('.m-product-media');
      if (!mediaSlider) return;

      const spinButton = mediaSlider.querySelector('[data-product-media-mode-button="spin"]');
      const spinSlide = mediaSlider.querySelector('.m-product-media__spin[data-media-id]');
      const mediaId = (spinButton && spinButton.dataset.mediaId) || (spinSlide && spinSlide.dataset.mediaId);
      if (!mediaId) return;

      pauseProductMediaVideos();
      if (resetPoster) resetPosterState();
      slideMainToMediaId(mediaId, 0);
      if (spinButton) setActiveMediaMode(spinButton);

      const optionThumb = mediaSlider.querySelector('[data-product-spin-option-thumb].is-spin-option-active');
      const spinThumb = optionThumb || mediaThumbForId(mediaId);
      if (spinThumb) setActiveMediaThumb(spinThumb);
    };

    const activateMediaModeButton = (button) => {
      if (!button) return;
      const mode = button.dataset.productMediaModeButton || '';
      if (mode === 'spin') {
        activateSpinMediaMode(true);
        return;
      }

      const mediaId = button.dataset.mediaId || '';
      if (!mediaId) return;
      const slide = mediaSlideForId(mediaId);
      const video = prepareMediaSlide(slide);
      pauseProductMediaVideos(video);
      slideMainToMediaId(mediaId, 0);
      setActiveMediaMode(button);

      const thumb = mediaThumbForId(mediaId);
      if (thumb) setActiveMediaThumb(thumb);

      if (video) {
        const playback = video.play();
        if (playback && typeof playback.catch === 'function') {
          playback.catch(() => setVideoPreviewVisible(video, true));
        }
      }
    };

    const configureMobileStaticMedia = () => {
      const mediaSlider = viewer.closest('.m-product-media--has-spin-first');
      if (!mediaSlider || mediaSlider.dataset.productSpinMobileStaticBound === 'true') return;

      // The static mobile viewer is only needed when the product exposes
      // explicit 360 / Graphic ID / Texture mode buttons. Holder products use
      // the regular Swiper gallery, so marking them as static would hide their
      // only spin slide without assigning an active media mode.
      const mobileModeButtons = mediaSlider.querySelectorAll('[data-product-media-mode-button]');
      if (mobileModeButtons.length === 0) return;

      mediaSlider.dataset.productSpinMobileStaticBound = 'true';
      const initialSpinButton = mediaSlider.querySelector('[data-product-media-mode-button="spin"]');
      if (initialSpinButton) setActiveMediaMode(initialSpinButton);
      const mainSlider = mediaSlider.querySelector('.js-product-media-items');
      const thumbsSlider = mediaSlider.querySelector('.js-product-media-thumbs');
      let mobileModeInitialized = false;

      const apply = () => {
        const lockTouch = mobileSpinMediaQuery.matches;

        [mainSlider, thumbsSlider].forEach((slider) => {
          if (!slider || !slider.swiper) return;
          slider.swiper.allowTouchMove = !lockTouch;
          slider.swiper.params.allowTouchMove = !lockTouch;
          slider.swiper.params.simulateTouch = !lockTouch;
          slider.swiper.update();
        });

        if (lockTouch && mainSlider && mainSlider.swiper && !mobileModeInitialized) {
          mobileModeInitialized = true;
          activateSpinMediaMode(false);
        } else if (!lockTouch) {
          mobileModeInitialized = false;
        }

        if (mainSlider && mainSlider.swiper && mainSlider.dataset.productMediaModeSyncBound !== 'true') {
          mainSlider.dataset.productMediaModeSyncBound = 'true';
          mainSlider.swiper.on('slideChange', () => {
            const activeSlide = mainSlider.swiper.slides[mainSlider.swiper.activeIndex];
            const modeButton = activeSlide && mediaModeButtonForId(activeSlide.dataset.mediaId);
            if (modeButton) setActiveMediaMode(modeButton);
          });
        }
      };

      const scheduleApply = () => {
        apply();
        [80, 240, 600].forEach((delay) => {
          window.setTimeout(apply, delay);
        });
      };

      scheduleApply();

      if (typeof mobileSpinMediaQuery.addEventListener === 'function') {
        mobileSpinMediaQuery.addEventListener('change', scheduleApply);
      } else if (typeof mobileSpinMediaQuery.addListener === 'function') {
        mobileSpinMediaQuery.addListener(scheduleApply);
      }
    };

    const bindMediaThumbs = () => {
      const mediaSlider = viewer.closest('.m-product-media');
      if (!mediaSlider || mediaSlider.dataset.productSpinThumbsBound === 'true') return;

      mediaSlider.dataset.productSpinThumbsBound = 'true';
      configureMobileStaticMedia();
      mediaSlider.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;

        const modeButton = event.target.closest('[data-product-media-mode-button]');
        if (modeButton && mediaSlider.contains(modeButton)) {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          activateMediaModeButton(modeButton);
          return;
        }

        const thumb = event.target.closest('.m-product-media__thumb[data-media-id]');
        if (!thumb || !mediaSlider.contains(thumb)) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        const isOptionThumb = thumb.hasAttribute('data-product-spin-option-thumb');
        if (isOptionThumb) {
          selectVariantControl(thumb.dataset.productSpinOptionValue);

          const variantId = String(thumb.dataset.productSpinVariantId || '');
          if (variantId && variantConfigs.has(variantId)) {
            lastVariantId = '';
            updateForVariantId(variantId);
          } else {
            updateForCurrentVariant();
          }

          resetPosterState();
          syncOptionThumbs(activeConfig);
        }

        slideMainToMediaId(thumb.dataset.mediaId, 0);
        setActiveMediaThumb(thumb);
        const linkedModeButton = mediaModeButtonForId(thumb.dataset.mediaId);
        if (linkedModeButton) setActiveMediaMode(linkedModeButton);
      }, true);
    };

    // Keep full-resolution URLs untouched. Reserve one loader slot for the
    // latest target; speculative work and decoded-node retention are bounded.
    const trimDecodedFrames = () => {
      const candidates = [...decodedFrames.keys()].filter((index) => index !== frame);
      candidates.sort((a, b) => (
        Math.min(Math.abs(b - frame), Math.abs(b - displayedFrame)) -
        Math.min(Math.abs(a - frame), Math.abs(a - displayedFrame))
      ));
      while (decodedFrames.size > frameCacheLimit() && candidates.length) decodedFrames.delete(candidates.shift());
    };

    const frameInterestRadius = () => constrainedSpin ? 2 : 8;
    const frameIsRelevant = (index) => index === frame ||
      Math.abs(index - frame) <= frameInterestRadius() ||
      Math.abs(index - displayedFrame) <= (constrainedSpin ? 1 : 3) ||
      (dragRendering && dragDirection === Math.sign(frame - displayedFrame) &&
        (index - displayedFrame) * dragDirection > 0 && (frame - index) * dragDirection >= 0);

    const pruneFrameQueue = () => {
      frameQueue = frameQueue.filter((task) => {
        const keep = task.generation === frameGeneration && frameIsRelevant(task.index);
        if (!keep) {
          if (task.generation === frameGeneration) pendingFrames.delete(task.index);
          task.resolve(null);
        } else {
          task.priority = task.index === frame;
        }
        return keep;
      });
      frameQueue.sort((a, b) => Number(b.priority) - Number(a.priority) || Math.abs(a.index - frame) - Math.abs(b.index - frame));
    };

    const pumpFrameQueue = () => {
      pruneFrameQueue();
      while (activeFrameLoads < frameLoadLimit && frameQueue.length) {
        // Speculation cannot occupy the last slot needed for a target request.
        if (!frameQueue[0].priority && activeFrameLoads >= Math.max(1, frameLoadLimit - 1)) break;
        const task = frameQueue.shift();
        activeFrameLoads += 1;
        const preloader = new Image();
        preloader.decoding = 'async';
        preloader.fetchPriority = task.priority ? 'high' : 'low';
        preloader.src = task.src;
        waitForImage(preloader).then((loaded) => {
          const valid = loaded && task.generation === frameGeneration;
          if (valid) estimatedFrameBytes = Math.max(estimatedFrameBytes, preloader.naturalWidth * preloader.naturalHeight * 4);
          if (valid && frameIsRelevant(task.index)) {
            decodedFrames.set(task.index, preloader);
            // A ready in-flight frame can be behind the latest target but still
            // advance the visible image. Consume it before a small cache evicts
            // it; never regress or overshoot after reversal/variant changes.
            const towardTarget = Math.sign(frame - displayedFrame);
            if (dragRendering && towardTarget && towardTarget === dragDirection &&
                (task.index - displayedFrame) * towardTarget > 0 &&
                (frame - task.index) * towardTarget >= 0) {
              renderReadyFrame(task.index, preloader);
            }
            trimDecodedFrames();
          }
          task.resolve(valid ? preloader : null);
          if (valid && dragRendering) scheduleDragRender();
        }).catch(() => task.resolve(null)).finally(() => {
          activeFrameLoads -= 1;
          if (task.generation === frameGeneration) pendingFrames.delete(task.index);
          pumpFrameQueue();
        });
      }
    };

    const loadFrame = (index, priority = false) => {
      const next = clamp(index);
      if (decodedFrames.has(next)) return Promise.resolve(decodedFrames.get(next));
      if (pendingFrames.has(next)) {
        const queued = frameQueue.find((task) => task.index === next && task.generation === frameGeneration);
        if (queued && priority) queued.priority = true;
        return pendingFrames.get(next);
      }
      pruneFrameQueue();
      if (frameQueue.length >= frameQueueLimit) {
        if (!priority) return Promise.resolve(null);
        const dropped = frameQueue.pop();
        pendingFrames.delete(dropped.index);
        dropped.resolve(null);
      }
      const pending = new Promise((resolve) => {
        frameQueue.push({ index: next, src: frames[next], generation: frameGeneration, priority, resolve });
      });
      pendingFrames.set(next, pending);
      Promise.resolve().then(pumpFrameQueue);
      return pending;
    };

    const currentSpinAtlasSpec = () => activeConfig && CORE_SPIN_ATLAS_CATALOG[activeConfig.base];
    const spinAtlasEligible = () => {
      const spec = currentSpinAtlasSpec();
      return Boolean(mobileSpinMediaQuery.matches && !saveData && !slowConnection && spec &&
        spec.count === frames.length && spec.pad === activeConfig.pad && spec.ext === activeConfig.ext && spec.version === activeConfig.version);
    };

    const spinAtlasState = (state) => {
      if (!spinAtlasEligible() && state !== 'released') return;
      viewer.dataset.productSpinAtlasPilot = 'cores-prepared-atlas-20261103-v5';
      viewer.dataset.productSpinAtlasTouch = 'shared-image-drag-20261103-v6';
      viewer.dataset.productSpinAtlasState = state;
      viewer.dataset.productSpinAtlasBase = activeConfig.base;
    };

    const hideSpinAtlas = () => {
      if (spinAtlasRaf) window.cancelAnimationFrame(spinAtlasRaf);
      spinAtlasRaf = 0;
      if (spinAtlasVisible) {
        for (const photo of [activeImage, standbyImage]) {
          photo.style.visibility = spinPhotoVisibility.get(photo) || '';
          spinPhotoVisibility.delete(photo);
        }
      }
      spinAtlasVisible = false;
      if (spinAtlasCanvas) spinAtlasCanvas.style.visibility = 'hidden';
    };

    const showSpinAtlasNotice = (show) => {
      if (!show) { if (spinAtlasNotice) spinAtlasNotice.remove(); spinAtlasNotice = null; return; }
      if (spinAtlasNotice) return;
      spinAtlasNotice = document.createElement('span');
      spinAtlasNotice.textContent = (document.documentElement.lang || '').toLowerCase().startsWith('ko')
        ? '회전 이미지를 준비 중입니다' : 'Preparing rotation images';
      spinAtlasNotice.setAttribute('role', 'status');
      spinAtlasNotice.style.cssText = 'position:absolute;top:8px;left:50%;transform:translateX(-50%);z-index:4;max-width:90%;padding:5px 8px;background:rgba(255,255,255,.92);color:#333;font-size:12px;line-height:1.4;white-space:nowrap;pointer-events:none';
      stage.appendChild(spinAtlasNotice);
    };

    const refreshSpinAtlasGeometry = () => {
      if (!spinAtlasCanvas) return;
      const width = stage.clientWidth;
      const height = stage.clientHeight;
      if (!width || !height) { spinAtlasGeometry = null; return; }
      const side = Math.min(width, height);
      const w = 512 * side / width;
      const h = 512 * side / height;
      spinAtlasGeometry = { x: (512 - w) / 2, y: (512 - h) / 2, w, h };
      spinAtlasCanvas.style.transform = window.getComputedStyle(activeImage).transform;
    };

    const drawSpinAtlas = (index, visible) => {
      if (!spinAtlasReady || !spinAtlasEligible() || !spinAtlasContext || !spinAtlasGeometry) return false;
      const n = clamp(index);
      const g = spinAtlasGeometry;
      spinAtlasContext.clearRect(0, 0, 512, 512);
      spinAtlasContext.drawImage(spinAtlasImage, (n % 13) * 288, Math.floor(n / 13) * 288, 288, 288, g.x, g.y, g.w, g.h);
      if (visible) {
        if (!spinAtlasVisible) {
          // Transparent preview pixels must not reveal a stale underlying pose.
          for (const photo of [activeImage, standbyImage]) {
            spinPhotoVisibility.set(photo, photo.style.visibility || '');
            photo.style.visibility = 'hidden';
          }
        }
        spinAtlasVisible = true;
        spinAtlasCanvas.style.visibility = 'visible';
        viewer.dataset.productSpinAtlasFrame = String(n + 1);
      }
      return true;
    };

    const scheduleSpinAtlasRender = () => {
      if (spinAtlasRaf) return;
      const generation = spinAtlasGeneration;
      spinAtlasRaf = window.requestAnimationFrame(() => {
        spinAtlasRaf = 0;
        if (generation !== spinAtlasGeneration || (!sliderGestureActive && !draggingSpin) || !spinAtlasReady || !spinAtlasEligible()) return;
        markSpinActive();
        updateStatus();
        drawSpinAtlas(frame, true);
      });
    };

    const releaseSpinAtlas = () => {
      hideSpinAtlas();
      spinAtlasGeneration += 1;
      window.clearTimeout(spinAtlasTimeout);
      spinAtlasTimeout = 0;
      spinAtlasReady = false;
      spinAtlasLoading = false;
      if (spinAtlasImage) { spinAtlasImage.onload = null; spinAtlasImage.onerror = null; spinAtlasImage.removeAttribute('src'); }
      spinAtlasImage = null;
      if (spinAtlasCanvas) { spinAtlasCanvas.width = 0; spinAtlasCanvas.height = 0; spinAtlasCanvas.remove(); }
      spinAtlasCanvas = null;
      spinAtlasContext = null;
      spinAtlasGeometry = null;
      showSpinAtlasNotice(false);
      delete viewer.dataset.productSpinAtlasFrame;
      delete viewer.dataset.productSpinAtlasPilot;
      delete viewer.dataset.productSpinAtlasState;
      delete viewer.dataset.productSpinAtlasBase;
      delete viewer.dataset.productSpinAtlasTouch;
    };

    const prepareSpinAtlas = () => {
      if (!spinAtlasEligible() || spinAtlasReady || spinAtlasLoading || viewer.dataset.productSpinAtlasState === 'fallback') return;
      const atlasSpec = currentSpinAtlasSpec();
      const generation = ++spinAtlasGeneration;
      spinAtlasLoading = true;
      spinAtlasState('loading');
      showSpinAtlasNotice(true);
      trimDecodedFrames();
      const fail = () => {
        if (generation !== spinAtlasGeneration) return;
        releaseSpinAtlas();
        spinAtlasState('fallback');
        if (sliderGestureActive || draggingSpin) { dragRendering = true; scheduleDragRender(); }
      };
      spinAtlasTimeout = window.setTimeout(fail, 8000);
      const atlas = new Image();
      spinAtlasImage = atlas;
      atlas.crossOrigin = 'anonymous';
      atlas.decoding = 'async';
      atlas.src = atlasSpec.url;
      waitForImage(atlas).then(async loaded => {
        if (!loaded || generation !== spinAtlasGeneration || !spinAtlasEligible()) { if (generation === spinAtlasGeneration) fail(); return; }
        if (atlas.naturalWidth !== 3744 || atlas.naturalHeight !== 3744) { fail(); return; }
        // Explicit retained decode. There is no frame download/decode inside an atlas scrub.
        if (typeof atlas.decode === 'function') await atlas.decode();
        if (generation !== spinAtlasGeneration || !spinAtlasEligible()) return;
        const canvas = document.createElement('canvas');
        canvas.width = 512; canvas.height = 512;
        canvas.setAttribute('aria-hidden', 'true');
        canvas.dataset.productSpinAtlasCanvas = 'cores-v5';
        canvas.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;visibility:hidden;pointer-events:none;z-index:2;opacity:1';
        const context = canvas.getContext('2d', { alpha: true });
        if (!context) { fail(); return; }
        spinAtlasCanvas = canvas;
        spinAtlasContext = context;
        context.imageSmoothingEnabled = true;
        context.imageSmoothingQuality = 'medium';
        stage.appendChild(canvas);
        refreshSpinAtlasGeometry();
        spinAtlasLoading = false;
        spinAtlasReady = true;
        decodedFrames.clear();
        // Stop obsolete speculative work. In-flight requests remain bounded and cannot replace the overlay.
        frameQueue.forEach(task => { pendingFrames.delete(task.index); task.resolve(null); });
        frameQueue = [];
        drawSpinAtlas(frame, false);
        // Pay initial raster preparation once, before a continuous gesture, not per frame.
        try { context.getImageData(0, 0, 1, 1); } catch (_error) { /* Drawing still works if readback is unavailable. */ }
        window.clearTimeout(spinAtlasTimeout); spinAtlasTimeout = 0;
        spinAtlasState('ready');
        showSpinAtlasNotice(false);
        if (sliderGestureActive || draggingSpin) {
          renderToken += 1;
          cancelDragRender();
          drawSpinAtlas(frame, true);
        }
      }).catch(fail);
    };

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden || (!spinAtlasReady && !spinAtlasLoading)) return;
      releaseSpinAtlas();
      if (sliderGestureActive) settleSlider();
      if (dragPointerId !== null) finishSpinDrag({ pointerId: dragPointerId });
    });

    window.addEventListener('resize', () => {
      if (!spinAtlasCanvas) return;
      if (!spinAtlasEligible()) { releaseSpinAtlas(); return; }
      refreshSpinAtlasGeometry();
      if (spinAtlasVisible) drawSpinAtlas(frame, true);
    }, { passive: true });

    const preloadAround = (center, radius = 3) => {
      if (!spinRequested || posterActive || document.hidden || ((spinAtlasLoading || spinAtlasReady) && spinAtlasEligible())) return;
      for (let offset = 1; offset <= radius; offset += 1) {
        loadFrame(center + offset);
        loadFrame(center - offset);
      }
    };

    const beginIdlePreload = () => {
      preloadAround(frame, constrainedSpin ? 1 : 4);
    };

    const activateStandbyImage = () => {
      const previousImage = activeImage;
      const nextImage = standbyImage;
      previousImage.classList.remove('is-active');
      previousImage.removeAttribute('data-product-spin-image');
      previousImage.setAttribute('aria-hidden', 'true');
      previousImage.setAttribute('alt', '');
      nextImage.classList.add('is-active');
      nextImage.setAttribute('data-product-spin-image', '');
      nextImage.removeAttribute('aria-hidden');
      nextImage.setAttribute('alt', imageAlt);
      activeImage = nextImage;
      standbyImage = previousImage;
    };

    const renderReadyFrame = (index, loadedImage) => {
      if (!loadedImage || !loadedImage.complete || !loadedImage.naturalWidth) return false;
      if (loadedImage !== activeImage) {
        if (loadedImage !== standbyImage) {
          // Reuse the already-decoded node, preserving the stage image's markup
          // and two-node swap. Never clear the currently visible image first.
          [...loadedImage.attributes].forEach((attribute) => {
            if (attribute.name !== 'src') loadedImage.removeAttribute(attribute.name);
          });
          [...standbyImage.attributes].forEach((attribute) => {
            if (attribute.name !== 'src') loadedImage.setAttribute(attribute.name, attribute.value);
          });
          stage.replaceChild(loadedImage, standbyImage);
          standbyImage = loadedImage;
        }
        activateStandbyImage();
      }
      displayedFrame = index;
      if (spinAtlasVisible && !sliderGestureActive && !draggingSpin && index === frame) hideSpinAtlas();
      trimDecodedFrames();
      return true;
    };

    const nearestReadyDragFrame = () => {
      const direction = Math.sign(frame - displayedFrame);
      if (!direction || direction !== dragDirection) return null;
      let best = null;
      for (const [index, loadedImage] of decodedFrames) {
        // Only move between the visible frame and the latest target. A late
        // completion from a previous direction must never rewind the display.
        if ((index - displayedFrame) * direction <= 0 || (frame - index) * direction < 0) continue;
        if (best === null || Math.abs(frame - index) < Math.abs(frame - best)) best = index;
      }
      return best;
    };

    const preloadDragFrames = () => {
      if (posterActive || document.hidden) return;
      const lookahead = Math.min(frameInterestRadius(), Math.max(constrainedSpin ? 1 : 2, Math.ceil(dragVelocity * 80)));
      for (let offset = 1; offset <= lookahead; offset += 1) loadFrame(frame + dragDirection * offset);
      preloadAround(displayedFrame, constrainedSpin ? 1 : 2);
      preloadAround(frame, constrainedSpin ? 1 : 2);
    };

    const scheduleDragRender = () => {
      if (dragRaf || !dragRendering) return;
      const generation = frameGeneration;
      dragRaf = window.requestAnimationFrame((time) => {
        dragRaf = 0;
        if (generation !== frameGeneration || !dragRendering || posterActive) return;
        const elapsed = Math.max(16, time - dragSampleTime);
        dragVelocity = Math.abs(frame - dragSampleFrame) / elapsed;
        dragSampleTime = time;
        dragSampleFrame = frame;
        markSpinActive();
        updateStatus();
        // Target first, then a ready fallback, then strictly bounded lookahead.
        loadFrame(frame, true);
        const ready = nearestReadyDragFrame();
        if (ready !== null) renderReadyFrame(ready, decodedFrames.get(ready));
        preloadDragFrames();
        trimDecodedFrames();
      });
    };

    const showFrame = (index) => {
      spinRequested = true;
      cancelDragRender();
      const next = clamp(index);
      const token = ++renderToken;
      const generation = frameGeneration;
      frame = next;
      if (spinAtlasVisible && spinAtlasReady && spinAtlasEligible()) drawSpinAtlas(next, true);
      markSpinActive();
      updateStatus();
      const pending = loadFrame(next, true);
      preloadAround(next, constrainedSpin ? 1 : 4);
      pending.then(async (loadedImage) => {
        if (generation !== frameGeneration || renderToken !== token || frame !== next || posterActive) return;
        if (spinAtlasVisible && loadedImage && typeof loadedImage.decode === 'function') {
          try { await loadedImage.decode(); } catch (_error) { return; }
          if (generation !== frameGeneration || renderToken !== token || frame !== next || posterActive) return;
        }
        renderReadyFrame(next, loadedImage);
      });
    };

    const applyConfig = (nextConfig) => {
      const normalized = normalizeConfig(nextConfig);
      if (!normalized) return;
      if (activeConfig && activeConfig.base === normalized.base && activeConfig.count === normalized.count &&
          activeConfig.pad === normalized.pad && activeConfig.ext === normalized.ext && activeConfig.version === normalized.version) return;

      releaseSpinAtlas();
      activeConfig = normalized;
      frames = buildFrames(activeConfig);
      frame = initialFrameIndex();
      cancelDragRender();
      draggingSpin = false;
      dragPointerId = null;
      dragDistance = 0;
      sliderGestureActive = false; sliderTouchId = null; window.clearTimeout(sliderSettleTimer); sliderSettleTimer = 0;
      dragDirection = 0;
      stage.classList.remove('is-spin-dragging');
      displayedFrame = frame;
      decodedFrames = new Map();
      pendingFrames = new Map();
      frameGeneration += 1;
      frameQueue.forEach((task) => task.resolve(null));
      frameQueue = [];
      renderToken += 1;
      wheelDelta = 0;
      posterActive = Boolean(posterMode && activeConfig.poster && !controlsReady);

      activeImage.src = posterActive ? activeConfig.poster : frames[frame];
      activeImage.classList.add('is-active');
      activeImage.setAttribute('data-product-spin-image', '');
      activeImage.removeAttribute('aria-hidden');
      activeImage.setAttribute('alt', imageAlt);
      standbyImage.removeAttribute('src');
      standbyImage.classList.remove('is-active');
      standbyImage.removeAttribute('data-product-spin-image');
      standbyImage.setAttribute('aria-hidden', 'true');
      standbyImage.setAttribute('alt', '');

      viewer.dataset.frameBase = activeConfig.base;
      viewer.dataset.frameCount = String(activeConfig.count);
      viewer.dataset.frameVersion = activeConfig.version || '';
      viewer.dataset.posterUrl = activeConfig.poster || '';
      viewer.classList.remove('is-spin-active');
      syncPosterClass();
      setControlsReady(controlsReady || !posterActive);
      updateLinkedThumb(activeConfig.poster);
      scheduleSpinSlideFocus();

      updateStatus();
      preloadAround(frame, saveData || slowConnection ? 1 : 4);
    };

    const variantIdFromSelectedOptions = () => {
      const selectedOptions = selectedOptionsFromControls(viewer);
      if (!selectedOptions.values.length) return '';

      for (const [variantId, config] of variantConfigs.entries()) {
        if (!config || !Array.isArray(config.options) || !config.options.length) continue;

        const matched = config.options.every((option, index) => {
          const selectedByName = selectedOptions.byName.get(option.name);
          if (selectedByName) return normalizeOptionValue(selectedByName) === normalizeOptionValue(option.value);
          return normalizeOptionValue(selectedOptions.values[index]) === normalizeOptionValue(option.value);
        });

        if (matched) return variantId;
      }

      for (const [variantId, config] of variantConfigs.entries()) {
        if (!config || !Array.isArray(config.values) || !config.values.length) continue;
        const matched = config.values.every((value, index) => (
          normalizeOptionValue(selectedOptions.values[index]) === normalizeOptionValue(value)
        ));
        if (matched) return variantId;
      }

      if (selectedOptions.values.length === 1) {
        const selectedValue = normalizeOptionValue(selectedOptions.values[0]);
        for (const [variantId, config] of variantConfigs.entries()) {
          if (normalizeOptionValue(config && config.title) === selectedValue) return variantId;
        }
      }

      return '';
    };

    const currentVariantId = () => {
      const variantFromOptions = variantIdFromSelectedOptions();
      if (variantFromOptions && variantConfigs.has(String(variantFromOptions))) return String(variantFromOptions);

      const fields = document.querySelectorAll('form[action*="/cart/add"] [name="id"]');
      for (const field of fields) {
        const value = selectedVariantIdFromField(field);
        if (value && variantConfigs.has(String(value))) return String(value);
      }

      const variantFromUrl = new URLSearchParams(window.location.search).get('variant');
      if (variantFromUrl && variantConfigs.has(String(variantFromUrl))) return String(variantFromUrl);

      return viewer.dataset.currentVariantId || '';
    };

    const updateForVariantId = (variantId) => {
      const nextId = String(variantId || '');
      if (!nextId) return;
      if (nextId === lastVariantId) {
        syncOptionThumbs(variantConfigs.get(nextId) || activeConfig);
        return;
      }
      lastVariantId = nextId;
      viewer.dataset.currentVariantId = nextId;
      const nextConfig = variantConfigs.get(nextId) || fallbackConfig;
      applyConfig(nextConfig);
      if (mobileSpinMediaQuery.matches) activateSpinMediaMode(true);
    };

    const updateForCurrentVariant = () => {
      updateForVariantId(currentVariantId());
    };

    const stepFrame = (amount) => {
      showFrame(frame + amount);
      beginIdlePreload();
    };

    range.addEventListener('input', () => {
      renderSliderTarget();
      if (!sliderGestureActive) beginIdlePreload();
      else scheduleSliderFallback();
    });

    range.addEventListener('change', () => {
      if (sliderGestureActive) return;
      if (sliderLastSettledValue === String(sliderTarget())) { sliderLastSettledValue = ''; return; }
      showFrame(sliderTarget());
      beginIdlePreload();
    });
    range.addEventListener('pointerdown', startSliderGesture, { capture: true });
    const endSliderPointer = (event) => {
      if (!sliderGestureActive || sliderPointerId === null) return;
      if (event.pointerId !== undefined && event.pointerId !== sliderPointerId) return;
      settleSlider();
    };
    range.addEventListener('pointerup', endSliderPointer, { capture: true });
    range.addEventListener('pointercancel', endSliderPointer, { capture: true });
    range.addEventListener('lostpointercapture', endSliderPointer, { capture: true });
    document.addEventListener('pointerup', endSliderPointer, { capture: true });
    document.addEventListener('pointercancel', endSliderPointer, { capture: true });
    document.addEventListener('lostpointercapture', endSliderPointer, { capture: true });
    range.addEventListener('touchstart', (event) => {
      if (!event.changedTouches || !event.changedTouches.length) return;
      if (event.isPrimary === false) return;
      if (sliderGestureActive) {
        if (sliderPointerId !== null) sliderTouchId = event.changedTouches[0].identifier;
        return;
      }
      sliderTouchId = event.changedTouches[0].identifier;
      sliderGestureActive = true; sliderPointerId = null; sliderLastSettledValue = ''; window.clearTimeout(sliderSettleTimer);
      if (spinAtlasReady && spinAtlasEligible()) {
        renderToken += 1; cancelDragRender(); refreshSpinAtlasGeometry(); drawSpinAtlas(frame, true);
      }
    }, { capture: true, passive: true });
    const endSliderTouch = (event) => {
      if (!sliderGestureActive || sliderTouchId === null) return;
      if (event.changedTouches && !Array.from(event.changedTouches).some((touch) => touch.identifier === sliderTouchId)) return;
      settleSlider();
    };
    range.addEventListener('touchend', endSliderTouch, { capture: true, passive: true });
    range.addEventListener('touchcancel', endSliderTouch, { capture: true, passive: true });
    document.addEventListener('touchend', endSliderTouch, { capture: true, passive: true });
    document.addEventListener('touchcancel', endSliderTouch, { capture: true, passive: true });
    range.addEventListener('keydown', (event) => {
      if (!sliderGestureActive || !['ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End','PageUp','PageDown'].includes(event.key)) return;
      settleSlider();
    }, { capture: true });

    stage.addEventListener('wheel', (event) => {
      const rawDelta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX;
      if (rawDelta === 0) return;
      const direction = rawDelta > 0 ? 1 : -1;
      const next = clamp(frame + direction);
      if (next === frame) {
        wheelDelta = 0;
        return;
      }

      event.preventDefault();
      wheelDelta += rawDelta;
      if (Math.abs(wheelDelta) < 28) return;

      stepFrame(direction);
      wheelDelta = 0;
    }, { passive: false });

    const finishSpinDrag = (event) => {
      if (dragPointerId === null || (event.pointerId !== undefined && event.pointerId !== dragPointerId)) return;
      const settle = draggingSpin;
      const pointerId = dragPointerId;
      dragPointerId = null;
      draggingSpin = false;
      dragDistance = 0;
      stage.classList.remove('is-spin-dragging');
      // Clear state before release (lostpointercapture can fire synchronously).
      if (stage.hasPointerCapture && stage.hasPointerCapture(pointerId)) stage.releasePointerCapture(pointerId);
      if (settle) showFrame(frame);
      else cancelDragRender();
      beginIdlePreload();
    };

    stage.addEventListener('pointerdown', (event) => {
      if (event.isPrimary === false || dragPointerId !== null) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      // Keep the selected decoded atlas for image drags as well as the range.
      if (!spinAtlasEligible()) releaseSpinAtlas();
      sliderGestureActive = false; sliderPointerId = null; sliderTouchId = null; window.clearTimeout(sliderSettleTimer); sliderSettleTimer = 0;
      dragPointerId = event.pointerId;
      dragPointerType = event.pointerType || 'mouse';
      // About 1.5 image widths traverses the available sequence; retain its ends.
      // Capture this scale per gesture so resizing cannot make an active drag jump.
      const dragWidth = stage.getBoundingClientRect().width || 328;
      dragPixelsPerFrame = Math.max(2, Math.min(10, dragWidth * 1.5 / Math.max(frames.length - 1, 1)));
      dragStartX = event.clientX;
      dragStartY = event.clientY;
      dragLastX = event.clientX;
      dragDistance = 0;
      draggingSpin = false;
      cancelDragRender();
      dragDirection = 0;
      dragVelocity = 0;
      dragSampleTime = performance.now();
      dragSampleFrame = frame;
      activateControls();
    }, { capture: true });

    stage.addEventListener('pointermove', (event) => {
      if (dragPointerId === null || event.pointerId !== dragPointerId) return;
      const totalX = event.clientX - dragStartX;
      const totalY = event.clientY - dragStartY;

      if (!draggingSpin) {
        if (dragPointerType === 'mouse') {
          // Mouse diagonals are normal hand motion, not a touch-scroll gesture.
          // Ignore Y rather than cancelling; pure vertical motion still does not rotate.
          if (Math.abs(totalX) < 6) return;
        } else {
          // Touch/pen retain the vertical-scroll lock before horizontal intent is clear.
          if (Math.abs(totalX) < 6 && Math.abs(totalY) < 6) return;
          if (Math.abs(totalY) >= Math.abs(totalX)) {
            finishSpinDrag(event);
            return;
          }
        }
        // A horizontal gesture owns rendering until release; reject stale settles.
        renderToken += 1;
        cancelDragRender();
        draggingSpin = true;
        prepareSpinAtlas();
        if (spinAtlasReady && spinAtlasEligible()) {
          refreshSpinAtlasGeometry();
          markSpinActive();
          drawSpinAtlas(frame, true);
        }
        stage.classList.add('is-spin-dragging');
        if (stage.setPointerCapture) stage.setPointerCapture(dragPointerId);
      }

      if (event.cancelable) event.preventDefault();
      dragDistance += event.clientX - dragLastX;
      dragLastX = event.clientX;
      const frameSteps = Math.trunc(dragDistance / dragPixelsPerFrame);
      if (!frameSteps) return;
      dragDistance -= frameSteps * dragPixelsPerFrame;
      const next = clamp(frame - frameSteps);
      if (next === frame) return;
      dragDirection = Math.sign(next - frame);
      frame = next;
      renderToken += 1; // Invalidate any older exact/activation render.
      if (spinAtlasReady && spinAtlasEligible()) {
        cancelDragRender();
        scheduleSpinAtlasRender();
      } else {
        dragRendering = true;
        scheduleDragRender();
      }
    }, { capture: true, passive: false });

    stage.addEventListener('pointerup', finishSpinDrag, { capture: true });
    stage.addEventListener('pointercancel', finishSpinDrag, { capture: true });
    stage.addEventListener('lostpointercapture', finishSpinDrag);
    document.addEventListener('pointerup', finishSpinDrag, { capture: true });
    document.addEventListener('pointercancel', finishSpinDrag, { capture: true });

    if (activateNode) {
      activateNode.addEventListener('click', activateControls);
    }

    if (posterMode) {
      stage.addEventListener('click', activateControls);
    }

    stopSpinTouchLeak(stage);
    stopSpinTouchLeak(range);
    stopSpinTouchLeak(activateNode);

    if (variantConfigs.size) {
      const scheduleVariantUpdate = () => {
        [0, 80, 240].forEach((delay) => {
          window.setTimeout(updateForCurrentVariant, delay);
        });
      };

      document.addEventListener('change', (event) => {
        if (!(event.target instanceof Element)) return;
        if (
          event.target.matches('[name="id"]') ||
          event.target.matches('.js-variants input, .js-variants select') ||
          event.target.closest('form[action*="/cart/add"]')
        ) {
          scheduleVariantUpdate();
        }
      });

      document.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('.js-variants label, .js-variants input, .js-variants select')) {
          scheduleVariantUpdate();
        }
      });

      ['variant:change', 'variantChange', 'product:variant-change'].forEach((eventName) => {
        document.addEventListener(eventName, (event) => {
          const variantId = event.detail && event.detail.variant && event.detail.variant.id;
          if (variantId) {
            updateForVariantId(variantId);
            return;
          }
          scheduleVariantUpdate();
        });
      });

      window.addEventListener('popstate', updateForCurrentVariant);
      window.setInterval(updateForCurrentVariant, 500);
    }

    syncPosterClass();
    bindMediaThumbs();
    syncOptionThumbs(variantConfigs.get(currentVariantId()) || activeConfig);
    setControlsReady(controlsReady);
    updateStatus();
    preloadAround(frame, saveData || slowConnection ? 1 : 4);
    updateForCurrentVariant();

    });
  };

  window.__acsInitializeProductSpinViewers = initializeProductSpinViewers;

  const boot = () => initializeProductSpinViewers(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeProductSpinViewers(event.target);
  });
  window.addEventListener('pageshow', boot);
})();
